module.exports = __webpack_public_path__ + "static/media/icono_organigrama.a5affcb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_organigrama.png
// module id = 812
// module chunks = 0